import React, { useEffect, useState } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import { logDOM } from "@testing-library/react";
import ConsultaModal from "./ConsultaModal";

const Consultas = (props) => {
  document.title = "Consultas | Dashboard Olis";

  const [modal, setModal] = useState(false);
  const [consultaEditavel, setconsultaEditavel] = useState(null);
  const [turmas, setTurmas] = useState([]);
  const [singlebtn1, setSinglebtn1] = useState(false);
  const [todasAsConsultas, setTodasAsConsultas] = useState(null);

  const [data, setData] = useState({
    columns: [
      // { label: "ID", field: "id_consulta", sort: "asc", width: 150 },
      { label: "Data", field: "data", sort: "asc", width: 150 },
      { label: "Hora", field: "hora", sort: "asc", width: 150 },
      { label: "Cliente", field: "cliente", sort: "asc", width: 150 },
      { label: "Médico", field: "medico", sort: "asc", width: 150 },
      { label: "Área", field: "area", sort: "asc", width: 150 },
      { label: "Serviço", field: "servico", sort: "asc", width: 150 },
      { label: "Status", field: "status", sort: "asc", width: 150 },
      { label: "Mensagem", field: "observacao", sort: "asc", width: 150 },
    ],
    rows: [],
  });

  const toggleModal = () => setModal(!modal);

  const handleAdd = () => {
    setconsultaEditavel(null);
    toggleModal();
  };

  const handleOnClienteEdicao = (texto, type) => {
    if (type === "success") {
      toast.success(texto);
    } else {
      toast.error(texto);
    }
  };

  // const handleSelecionarTurma = (turma) => {
  //   setConsultas(turma);
  // };

  useEffect(() => {
    getConsultas();
  }, []);

  const formatarData = (data) => {
    // Remove a parte do T para frente e cria a data apenas com a parte da data
    const dataSemHora = data.split("T")[0];
    const [ano, mes, dia] = dataSemHora.split("-");
    return `${dia}/${mes}/${ano}`;
  };

  const getConsultas = () => {
    fetch(`${process.env.REACT_APP_API}/consultas`)
      .then((response) => response.json())
      .then((response) => {
        setData((prevState) => ({
          ...prevState,
          rows: response.map((resposta) => ({
            // id_consulta: resposta.id_consulta,
            data: formatarData(resposta.data),
            hora: resposta.hora,
            cliente: resposta.cliente,
            medico: resposta.medico,
            area: resposta.area,
            servico: resposta.servico,
            status: resposta.status,
            observacao: resposta.message,

            clickEvent: () => {
              setconsultaEditavel(resposta);
              setModal(true);
            },
          })),
        }));
        setTodasAsConsultas(response);
      })
      .catch((error) => console.error("Erro ao buscar consultas:", error));
  };

  return (
    <React.Fragment>
      <ConsultaModal
        isOpen={modal}
        toggle={toggleModal}
        consultaEditavel={consultaEditavel}
        onClienteEdicao={handleOnClienteEdicao}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              {/* <Col sm={6}>
                <Dropdown
                  isOpen={singlebtn1}
                  toggle={() => setSinglebtn1(!singlebtn1)}
                >
                  <DropdownToggle className="btn btn-secondary" caret>
                    Escolha a turma <i className="mdi mdi-chevron-down" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {turmas &&
                      turmas.map((turma, index) => (
                        <DropdownItem
                          onClick={() => handleSelecionarTurma(turma)}
                          key={turma.id_serie}
                        >
                          {turma.descricao} ({turma.etapa})
                        </DropdownItem>
                      ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>

               <Button color="primary" onClick={handleAdd}>
                Adicionar Cliente
              </Button> */}
              {todasAsConsultas?.length > 0 && (
                <MDBDataTable striped responsive bordered data={data} />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, {})(Consultas);
